"use strict";
import React from "react";
import _ from "underscore";
import Autolinker from "autolinker";
import DOMPurify from "dompurify";
function lines(text) {
  return text.split("\n");
}
function line(text, idx) {
  var br = /* @__PURE__ */ React.createElement("br", null);
  const textWithFixedAngleBrackets = text.replace(
    /<([^<> ]*[.:][^<> ]*)>/g,
    (match, betweenAngleBrackets) => `&lt;${betweenAngleBrackets}&gt;`
  );
  const sanitizedText = DOMPurify.sanitize(textWithFixedAngleBrackets, {
    USE_PROFILES: { html: true }
  });
  const linkedText = Autolinker.link(sanitizedText, { newWindow: true });
  const sanitizedLinkedText = DOMPurify.sanitize(linkedText, {
    USE_PROFILES: { html: true }
  });
  return /* @__PURE__ */ React.createElement("span", { key: "line_" + idx }, /* @__PURE__ */ React.createElement("span", { dangerouslySetInnerHTML: { __html: sanitizedLinkedText } }), " ", idx === 0 ? "" : br);
}
function paragraph(para, index) {
  return /* @__PURE__ */ React.createElement("p", { key: "paragraph_" + index }, _.map(lines(para), line));
}
var SimpleHtmlFormat = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { "data-component": "SimpleHtmlFormat" }, _.map(this.paragraphs(), paragraph));
  },
  paragraphs: function() {
    var withoutCRs = (this.props.text || "").replace(/\r\n|\r/g, "\n");
    return withoutCRs.split("\n\n");
  }
});
export default SimpleHtmlFormat;
